(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('ProviderRepository', [
        'AprimaRestangular',
        'AprimaAnalytics',
        ProviderRepository
    ]);

    function ProviderRepository(
        AprimaRestangular,
        AprimaAnalytics
    ) {
        return {
            getProviderSupervisorListByProviderId: getProviderSupervisorListByProviderId,
            getProviderById: getProviderById,
            getSupervisorList: getSupervisorList,
            getDefaultSupervisor: getDefaultSupervisor
        };

        function getProviderSupervisorListByProviderId(providerId) {
            // var startTiming = function (page, category, label)
            var timing = AprimaAnalytics.startTiming('ProviderRepository', 'api', 'getProviderSupervisorListByProviderId');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('provider/' + providerId + '/supervisors')
                .get()
                .finally(timing.stop);
        }

        function getProviderById(providerId){
            var timing = AprimaAnalytics.startTiming('ProviderRepository', 'api', 'getProvider');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('provider/' + providerId)
                .get()
                .finally(timing.stop);
        }

        function getSupervisorList() {
            var timing = AprimaAnalytics.startTiming('ProviderRepository', 'api', 'getProvider');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('lists/provider')
                .get()
                .finally(timing.stop);
        }

        function getDefaultSupervisor(linkSupervisorDto) {
            var timing = AprimaAnalytics.startTiming('ProviderRepository', 'api', 'getDefaultSupervisor');
            var restangular = AprimaRestangular.get();
            return restangular
            .one('provider/default-supervisor')
            .get(linkSupervisorDto)
            .finally(timing.stop);
        }
    }
})();